"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  authorId: null,
  created: null,
  createdBy: null,
  embed_code: null,
  id: null,
  note: null,
  portalId: null,
  referencePageAuthor: null,
  referencePageFaviconUrl: null,
  referencePageFeaturedImageAltText: null,
  referencePageFeaturedImageUrl: null,
  referencePageTitle: null,
  referencePageQuote: null,
  referencePageUrl: null,
  type: null,
  updated: null,
  updatedBy: null
};

var Clip = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Clip, _Record);

  function Clip() {
    (0, _classCallCheck2.default)(this, Clip);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Clip).apply(this, arguments));
  }

  (0, _createClass2.default)(Clip, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Clip(data);
    }
  }]);
  return Clip;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Clip;
module.exports = exports.default;